module.exports = __webpack_public_path__ + "a300ea11f9cdf65ddc1181d4f39aea61.pdf";